import api from "./api";

export const getPersonaNatural = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaNaturalViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const getPersonaJuridica = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaJuridicaViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const getLugaresTrabajo = async () => {
    const response = await api.get(
        "/Persona/GetsListLegalPersonByTypeAndName?idType=-1&name="
    );

    return response.data.data;
}

export const buscarLugaresTrabajo = async (texto = "") => {
    const response = await api.get(
        `/Persona/GetsListLegalPersonByTypeAndName?idType=-1&name=${encodeURIComponent(texto || "")}`
    );

    return response.data.data;
}

export const addPersonaJuridicaRapida = async (razonSocial, idTipo = 0) => {
    const response = await api.post("/Persona/AddPersonaJuridicaRapida", { razonSocial, idTipo });

    return response.data.data;
}

export const getsPersonaVinculacionView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasVinculacionesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaVinculacion = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaVinculacion",{params: {idPersona, numero}}
    );

export const getsPersonaContactoView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasContactosViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaContacto = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaContacto",{params: {idPersona, numero}}
    )

export const getsPersonaDireccionView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasDireccionesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaDireccion = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaDireccion",{params: {idPersona, numero}}
    )

export const getsPersonaDocumentoView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasDocumentosViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}
export const GetsPersonaRepresentanteViewById = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetsPersonaRepresentanteViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}
export const deletePersonaDocumento = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaDocumento",{params: {idPersona, numero}}
    )
export const DeletePersonaRepresentante = (id) =>
    api.delete(
        "/Persona/DeletePersonaRepresentante",{params: {id}}
    )

export const getsPersonaAntecedenteView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasAntecedentesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaAntecedente = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaAntecedente",{params: {idPersona, numero}}
    )

export const getsPersonaDocumentoByTipoYNumeroView = async (idTipoDocumento, numeroDocumento) => {
    const response = await api.get(
        "/Persona/GetsPersonaDocumentoByTipoYNumero",{params: {idTipoDocumento, numeroDocumento}}
    );

    return response.data.data;
}

export const getPersonaById = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const getPersonaResumenBasicoById = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetTipoPersonaByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const addPersonaVinculacion = (vinculacion) =>
    api.post(
        "/Persona/AddPersonaVinculacion",vinculacion
    )

export const postPersonaNaturalUpdateWithDetails = (dataPost) =>
    api.post(
        "/Persona/PostPersonaNaturalUpdateWithDetails",dataPost
    )

export const postPersonaJuridicaUpdateWithDetails = (dataPost) =>
    api.post(
        "/Persona/PostPersonaJuridicaUpdateWithDetails",dataPost
    )

export const getPersonaResumenBasicoViewByNumeroDocumentoYNombres = async (numeroDocumento, nombres, empresa) => {
    const response = await api.get(
        "/Persona/GetPersonasResumenBasicoViewByNumeroDocumentoYNombres",{params: {numeroDocumento, nombres, empresa}}
    );

    return response.data.data;
}

// idTipoPersona: filtro del catalogo 22 (Padre, Participante, Terapeuta,
// Coordinador...). 0 es "todos".
export const getsPersonasResumenViewByNumeroDocumentoYNombres = async (numeroDocumento, nombres, empresa, idTipoPersona) => {
    const response = await api.get(
        "/Persona/GetPersonasResumenViewByNumeroDocumentoYNombres",{params: {numeroDocumento, nombres, empresa, idTipoPersona}}
    );

    return response.data.data;
}

export const getsPersonasResumenView = async () => {
    const response = await api.get(
        "/Persona/GetPersonasResumenView"
    );

    return response.data.data;
}
export const GetsListPersonaRepresentanteByIdPersona = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetsListPersonaRepresentanteByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}
// Los colegios: las personas juridicas cuyo tipo es Colegio (catalogo 229).
// Con texto, la busqueda de un autocomplete.
export const getsColegio = async (name = "") => {
    const response = await api.get(
        `/Persona/GetsListLegalPersonByTypeAndName?idType=229&name=${encodeURIComponent(name || "")}`
    );

    return response.data.data;
}
// Las personas de un tipo (25 = terapeuta, 24 = participante). Con texto es
// la busqueda de un autocomplete. Con todos se devuelve la lista entera: lo
// piden los reportes y las ventanas que filtran por terapeuta.
export const getsListNaturalPersonByTypeAndName = async (idType, name, todos = false) => {
    const response = await api.get(
        `/Persona/GetsListNaturalPersonByTypeAndName?idType=${idType}&name=${encodeURIComponent(name || "")}&todos=${todos ? "true" : "false"}`
    );

    return response.data.data;
}

// Todos los participantes, para el selector de participante. Con alfabetico
// el listado va en orden alfabetico (lo pide un autocomplete); si no, por la
// fecha de registro descendente (lo pide la navegabilidad).
export const getsParticipantesResumenView = async (alfabetico = false) => {
    const response = await api.get(
        `/Participante/GetsParticipantesResumenView?alfabetico=${alfabetico ? 1 : 0}`
    );

    return response.data.data;
}
